var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartupApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 315.38 243.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 157.76,
    y1: 17.76,
    x2: 157.76,
    y2: 233.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a8fd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 122.71,
    y1: 17.76,
    x2: 122.71,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 192.8,
    y1: 17.76,
    x2: 192.8,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 157.82,
    y1: 17.76,
    x2: 157.82,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 51.71,
    y1: 17.76,
    x2: 51.71,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 16.66,
    y1: 17.76,
    x2: 16.66,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 86.75,
    y1: 17.76,
    x2: 86.75,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 51.77,
    y1: 17.76,
    x2: 51.77,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 263.68,
    y1: 17.76,
    x2: 263.68,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 228.63,
    y1: 17.76,
    x2: 228.63,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 298.72,
    y1: 17.76,
    x2: 298.72,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 263.74,
    y1: 17.76,
    x2: 263.74,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 74.78,
    y1: 17.76,
    x2: 74.78,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 240.96,
    y1: 17.76,
    x2: 240.96,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 157.82,
    y1: 17.76,
    x2: 157.82,
    y2: 233.86,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ADMINDASH"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.72,71.26c-14.6,0-25.34-13.43-27.36-34.21-1.27-13.08,1-22.89,6.68-29.17C141.78,2.65,148.74,0,157.72,0c9.13,0,16.18,2.7,20.95,8,5.67,6.34,7.83,16.12,6.4,29.08h0C182.78,57.85,172,71.26,157.72,71.26Zm0-63.07c-6.67,0-11.45,1.7-14.62,5.19-4.08,4.5-5.62,12.2-4.59,22.87,1.59,16.3,9.13,26.82,19.21,26.82,9.86,0,17.4-10.54,19.2-26.87h0c1.17-10.54-.3-18.19-4.36-22.72C169.42,10,164.42,8.19,157.72,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.24,111.08h-8.19l.09-20.24A17.06,17.06,0,0,1,117.21,79c7.14-2.58,19-7.44,19.06-7.45l3.1,7.58S127.26,84.1,120,86.74a9.16,9.16,0,0,0-5.76,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.46,111.08h-8.19V92.2a9.18,9.18,0,0,0-5.76-5.46c-7.26-2.64-19.37-7.58-19.37-7.58l3.1-7.58S191.16,76.45,198.3,79a17.08,17.08,0,0,1,11.07,11.81l.09.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 153.73,
    y: 91.5,
    width: 8.19,
    height: 15.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.67,203.6c-14.6,0-25.34-13.44-27.36-34.22-1.27-13.08,1-22.89,6.68-29.17,4.74-5.23,11.7-7.88,20.68-7.88s16.18,2.7,21,8c5.67,6.34,7.82,16.12,6.4,29.08h0C76.73,190.18,66,203.6,51.67,203.6Zm0-63.08c-6.67,0-11.45,1.7-14.62,5.19-4.08,4.5-5.62,12.2-4.59,22.87,1.59,16.3,9.13,26.82,19.21,26.82,9.86,0,17.4-10.54,19.2-26.87h0c1.17-10.54-.3-18.19-4.36-22.72C63.37,142.3,58.37,140.52,51.67,140.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.19,243.41H0l.08-20.24a17.1,17.1,0,0,1,11.08-11.81c7.15-2.59,19.06-7.45,19.06-7.45l3.09,7.58s-12.1,4.94-19.36,7.58a9.13,9.13,0,0,0-5.76,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M103.4,243.41H95.21V224.53a9.13,9.13,0,0,0-5.75-5.46c-7.26-2.64-19.37-7.58-19.37-7.58l3.1-7.58s11.91,4.86,19.06,7.45a17.08,17.08,0,0,1,11.07,11.81l.08.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 47.67,
    y: 223.83,
    width: 8.19,
    height: 15.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.64,203.6c-14.6,0-25.33-13.44-27.36-34.22-1.27-13.07,1-22.89,6.68-29.17,4.74-5.23,11.7-7.88,20.68-7.88s16.18,2.7,20.95,8c5.67,6.33,7.83,16.12,6.4,29.08h0C288.7,190.18,278,203.6,263.64,203.6Zm0-63.08c-6.67,0-11.45,1.7-14.61,5.19-4.09,4.5-5.63,12.2-4.6,22.87,1.59,16.3,9.13,26.82,19.21,26.82,9.86,0,17.4-10.54,19.21-26.87h0c1.16-10.54-.31-18.19-4.36-22.72C275.34,142.3,270.34,140.52,263.64,140.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M220.17,243.41H212l.09-20.24a17.08,17.08,0,0,1,11.07-11.81c7.14-2.59,19-7.44,19.06-7.45l3.09,7.58s-12.1,4.94-19.36,7.58a9.13,9.13,0,0,0-5.75,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M315.38,243.41h-8.19V224.53a9.18,9.18,0,0,0-5.76-5.46c-7.26-2.64-19.36-7.58-19.36-7.58l3.09-7.58s11.92,4.86,19.06,7.45a17.08,17.08,0,0,1,11.07,11.81l.09.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 259.64,
    y: 223.83,
    width: 8.19,
    height: 15.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M56.23,123.57H48V91.79A11.86,11.86,0,0,1,59.89,79.94h41.64v8.19H59.89a3.66,3.66,0,0,0-3.66,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M267.71,123.57h-8.19V91.79a3.66,3.66,0,0,0-3.66-3.66H214.22V79.94h41.64a11.87,11.87,0,0,1,11.85,11.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M164.06,222.65H151.58a4.1,4.1,0,0,1-3.88-2.8l-3.53-10.54-.8-.33-10,5a4.09,4.09,0,0,1-4.73-.76l-8.82-8.83a4.09,4.09,0,0,1-.77-4.72l5-10-.33-.8-10.54-3.53a4.1,4.1,0,0,1-2.8-3.88V169a4.1,4.1,0,0,1,2.8-3.88l10.54-3.53.33-.8-5-10a4.09,4.09,0,0,1,.77-4.72l8.82-8.82a4.11,4.11,0,0,1,4.73-.77l10,5,.8-.33,3.53-10.55a4.09,4.09,0,0,1,3.88-2.79h12.48a4.09,4.09,0,0,1,3.88,2.79l3.53,10.55.8.33,9.95-5a4.11,4.11,0,0,1,4.73.77l8.82,8.82a4.11,4.11,0,0,1,.77,4.72l-5,10,.33.8,10.54,3.53a4.1,4.1,0,0,1,2.8,3.88v12.48a4.1,4.1,0,0,1-2.8,3.88l-10.54,3.53-.33.8,5,10a4.11,4.11,0,0,1-.77,4.72L187,213.17a4.06,4.06,0,0,1-4.73.76l-9.95-5-.8.33-3.53,10.54A4.1,4.1,0,0,1,164.06,222.65Zm-9.53-8.2h6.58l3.19-9.51a4.08,4.08,0,0,1,2.31-2.48l4.25-1.77a4.12,4.12,0,0,1,3.4.12l9,4.48,4.65-4.65-4.47-9a4,4,0,0,1-.12-3.4l1.76-4.25a4.09,4.09,0,0,1,2.48-2.32l9.51-3.18v-6.58l-9.51-3.19a4.09,4.09,0,0,1-2.48-2.32l-1.76-4.24a4.08,4.08,0,0,1,.11-3.4l4.48-9-4.65-4.65-9,4.48a4.16,4.16,0,0,1-3.4.11L166.61,148a4.08,4.08,0,0,1-2.31-2.48L161.11,136h-6.58l-3.19,9.52A4.08,4.08,0,0,1,149,148l-4.25,1.76a4.12,4.12,0,0,1-3.4-.12l-9-4.47-4.65,4.65,4.48,9a4.16,4.16,0,0,1,.11,3.4l-1.76,4.24a4.09,4.09,0,0,1-2.48,2.32l-9.52,3.19v6.58l9.52,3.18a4.09,4.09,0,0,1,2.48,2.32l1.76,4.25a4.12,4.12,0,0,1-.12,3.4l-4.47,9,4.65,4.65,9-4.48a4,4,0,0,1,3.4-.12l4.25,1.77a4.08,4.08,0,0,1,2.31,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M157.82,193.92a18.71,18.71,0,1,1,18.7-18.7A18.73,18.73,0,0,1,157.82,193.92Zm0-29.21a10.51,10.51,0,1,0,10.51,10.51A10.52,10.52,0,0,0,157.82,164.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupApplication);
export default __webpack_public_path__ + "static/media/startup_application.9a2a5e56d9c7f4cd14f94f143688658e.svg";
export { ForwardRef as ReactComponent };